__turbopack_context__.v({
  "active": "CampaignsModule-module__MREwWG__active",
  "appBody": "CampaignsModule-module__MREwWG__appBody",
  "appHeader": "CampaignsModule-module__MREwWG__appHeader",
  "appWindow": "CampaignsModule-module__MREwWG__appWindow",
  "badge": "CampaignsModule-module__MREwWG__badge",
  "blink": "CampaignsModule-module__MREwWG__blink",
  "chatBubble": "CampaignsModule-module__MREwWG__chatBubble",
  "clicked": "CampaignsModule-module__MREwWG__clicked",
  "cursor": "CampaignsModule-module__MREwWG__cursor",
  "description": "CampaignsModule-module__MREwWG__description",
  "dispatchBtn": "CampaignsModule-module__MREwWG__dispatchBtn",
  "featureIcon": "CampaignsModule-module__MREwWG__featureIcon",
  "featureItem": "CampaignsModule-module__MREwWG__featureItem",
  "featureList": "CampaignsModule-module__MREwWG__featureList",
  "formSection": "CampaignsModule-module__MREwWG__formSection",
  "headerIcon": "CampaignsModule-module__MREwWG__headerIcon",
  "headerTitle": "CampaignsModule-module__MREwWG__headerTitle",
  "inputField": "CampaignsModule-module__MREwWG__inputField",
  "inputGroup": "CampaignsModule-module__MREwWG__inputGroup",
  "mockupContainer": "CampaignsModule-module__MREwWG__mockupContainer",
  "moduleWrapper": "CampaignsModule-module__MREwWG__moduleWrapper",
  "optionBox": "CampaignsModule-module__MREwWG__optionBox",
  "optionsGrid": "CampaignsModule-module__MREwWG__optionsGrid",
  "panelCard": "CampaignsModule-module__MREwWG__panelCard",
  "panelTitle": "CampaignsModule-module__MREwWG__panelTitle",
  "phoneAvatar": "CampaignsModule-module__MREwWG__phoneAvatar",
  "phoneChat": "CampaignsModule-module__MREwWG__phoneChat",
  "phoneFooter": "CampaignsModule-module__MREwWG__phoneFooter",
  "phoneHeader": "CampaignsModule-module__MREwWG__phoneHeader",
  "phoneInput": "CampaignsModule-module__MREwWG__phoneInput",
  "phoneMic": "CampaignsModule-module__MREwWG__phoneMic",
  "phoneSimulator": "CampaignsModule-module__MREwWG__phoneSimulator",
  "phoneStatus": "CampaignsModule-module__MREwWG__phoneStatus",
  "phoneTitle": "CampaignsModule-module__MREwWG__phoneTitle",
  "popBubble": "CampaignsModule-module__MREwWG__popBubble",
  "progressBarBg": "CampaignsModule-module__MREwWG__progressBarBg",
  "progressBarFill": "CampaignsModule-module__MREwWG__progressBarFill",
  "progressCard": "CampaignsModule-module__MREwWG__progressCard",
  "progressHeader": "CampaignsModule-module__MREwWG__progressHeader",
  "progressMeta": "CampaignsModule-module__MREwWG__progressMeta",
  "progressOverlay": "CampaignsModule-module__MREwWG__progressOverlay",
  "progressPct": "CampaignsModule-module__MREwWG__progressPct",
  "progressStatus": "CampaignsModule-module__MREwWG__progressStatus",
  "speedControl": "CampaignsModule-module__MREwWG__speedControl",
  "speedItem": "CampaignsModule-module__MREwWG__speedItem",
  "textContent": "CampaignsModule-module__MREwWG__textContent",
  "title": "CampaignsModule-module__MREwWG__title",
});
